import FilterImage from './FilterImage'

export default FilterImage
